import React, { FC } from 'react';
import styles from './terms-use.module.css';

export const TermsUse: FC = () => {
  return (
    <div className="text-left inline-flex flex-col items-start gap-[32px] relative">
      <div className="flex-col max-w-[1036px] items-start gap-[16px] flex relative flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] [font-family:var(--20-h2-font-family)] font-[number:var(--20-h2-font-weight)] text-[color:var(--primaryprimary)] text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap ">
          規範簡介
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              歐悅集團官方網站 (以下簡稱本網站) 是由{' '}
            </span>
            <span className="font-bold">
              歐悅國際股份有限公司 (以下簡稱本公司) 及其關係企業{' '}
            </span>
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              所建置及維運。為保障您的使用權益，應詳細閱讀使用者條款。使用者條款構成您與本公司及其關係企業間之約定，一旦您開始瀏覽、使用本網站之全部或部分功能時，即視為您已閱讀、暸解、並同意接受本使用者條款、使用者隱私權政策之所有內容，及您所使用之服務項目、內容與約定。如您不同意本使用者條款之任一部分或全部，請您立即停止使用本網站。您瞭解並同意本使用者條款為本服務之基本條款，並構成您與本公司及其關係企業約定間的一部分。
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              使用者同意，本公司及其關係企業在法律允許之範圍內有權在必要時單方修改或變更本使用者條款之內容，本公司及其關係企業得適時的依據法令、政策的更新以及優化使用者的使用體驗，用以增加、減少、修改或變更各類規則，並將透過本服務公佈最新的使用者條款及規則，不另作個別通知。若使用者於任何修改或變更本使用者條款後繼續使用本服務，則視為使用者已認真閱讀、充分瞭解並完全同意接受修改後之使用者條款；若您不同意，您應立即停止使用本服務。
            </span>
          </p>
        </div>
      </div>
      <div className="flex flex-col max-w-[1036px] items-start gap-[16px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          適用範圍
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="text-[#262831]">
              本《使用者規範》適用於所有由本公司及其關係企業提供的服務，以及在第三方網站提供的服務
              (例如廣告服務)。我們打造的眾多服務每天可協助許多人以嶄新方式探索世界並與他人互動。這些服務包括：
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="font-bold text-[#224f49] underline">
              歐悅連鎖精品汽車旅館
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="font-bold text-[#224f49] underline">
              歐悅農牧整合
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="font-bold text-[#224f49] underline">
              歐悅金融科技
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="font-bold text-[#224f49] underline">
              歐悅能源
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="font-bold text-[#224f49] underline">
              歐悅建設開發
              <br />
            </span>
          </p>
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-transparent text-[16px] tracking-[0] leading-[24px]">
            <span className="text-[#262831]">
              透過我們的服務，您能夠以多種方式管理您的隱私權設定。舉例來說，只要申請本公司及其關係企業會員，您就可以建立及管理相關服務內容。即使您登出了帳戶或是從未申請帳戶，仍可以使用許多本公司及其關係企業的服務。
            </span>
          </p>
        </div>
      </div>
      <div className="flex flex-col max-w-[1036px] items-start gap-[16px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          行為準則
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <ul
          className={`flex flex-col items-start gap-[8px] ${styles['cust-ul']}`}
        >
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              我們允許您持續使用本網站各個服務，惟您必須遵守本公司及其關係企業所提供各項政策規範，雖然我們授權您使用本網站各項服務，但在服務中之智慧財產權仍為本公司及其關係企業所有。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              尊重他人的權利，包括隱私權、智慧財產權及一般公眾所認定之倫理規範。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              切勿辱罵或傷害他人或自己，或是威脅或鼓吹他人從事這些行為，例如誤導、詐騙、非法冒用他人身分、誹謗、霸凌、騷擾或跟蹤他人。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              切勿濫用、破壞、干擾服務，或是導致服務中斷，例如以詐欺或詐騙手法存取或使用服務、導入惡意軟體、濫發垃圾內容、入侵或規避我們的系統或保護措施。當我們建立網站索引以便為您提供搜尋結果時，我們會遵守網站擁有者在網站程式碼中指定的標準使用限制，因此我們要求其他公司在使用我們的服務時必須遵守相同的規則。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              本網站或服務上儲存或發佈的內容可能受他人智慧財產權的保護。除非您有權這樣做，否則請勿複製、上傳、下載或共用檔案。您將對您或使用您帳戶的任何人在使用本網站或服務時複製、分享、上傳、下載或以其他方式使用的內容承擔全部責任。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              禁止使用自動化方法來使用網站或服務，向本網站伺服器發送的請求數量多於任何一般第三人在同一時間段內使用傳統
              Web 瀏覽器合理產生的請求數量。
              <br />
            </span>
          </li>
          <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              嚴禁出售、轉售或以任何名義代理本公司及其關係企業服務，除非獲得特別授權。
            </span>
          </li>
        </ul>
      </div>
      <div className="flex flex-col max-w-[1036px] items-start gap-[16px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          服務穩定性
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="flex flex-col items-start gap-[8px]">
          <p className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
            <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
              如發生下列情形之一時，本公司及其關係企業有權可以停止、中斷提供本網站，使用者不得因此請求賠償或補償：
              <br />
            </span>
          </p>
          <ul className={`${styles['cust-ul']}`}>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                電子通信設備進行必要之保養及施工、突發性之電子通信設備故障。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                對本網站相關軟硬體設備進行搬遷、更換、升級、保養或維修時。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                使用者有任何違反法令、本使用者條款或本服務相關約定之情形。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                因第三人之行為、非本公司及其關係企業所得以控制之事項、或其他不可歸責於本公司及其關係企業之事由所致之網站暫停、中斷或無法正常運作。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                由於天災等不可抗力之因素或其他不可歸責於本公司及其關係企業所致之網站暫停、中斷或無法正常運作。
                <br />
              </span>
            </li>
            <li className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
              <span className="[font-family:'Noto_Sans_TC',Helvetica] font-normal text-[#262831] text-[16px] tracking-[0] leading-[24px]">
                因本公司及其關係企業自身業務考量，包括但不限於商業合併、結束營業等。
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-col max-w-[1036px] items-start gap-[16px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="relative w-fit mt-[-1.00px] font-20-h2 font-[number:var(--20-h2-font-weight)] text-primaryprimary text-[length:var(--20-h2-font-size)] tracking-[var(--20-h2-letter-spacing)] leading-[var(--20-h2-line-height)] whitespace-nowrap [font-style:var(--20-h2-font-style)]">
          管轄及準據法
        </div>
        <img
          className="relative self-stretch w-full h-px object-cover"
          alt="Vector"
          src="/assets/images/privacy/vector-19-1.svg"
        />
        <div className="relative self-stretch [font-family:'Noto_Sans_TC',Helvetica] font-normal text-neutralneutral-900 text-[16px] tracking-[0] leading-[24px]">
          使用者與本公司及其關係企業如因使用本服務所生之爭議，使用者與本公司同意以臺灣臺北地方法院為第一審管轄法院，並以中華民國法律為準據法。
        </div>
      </div>
    </div>
  );
};
